import { render } from "./TSACalendarNextItem.vue?vue&type=template&id=318ece1f"
import script from "./TSACalendarNextItem.vue?vue&type=script&lang=js"
export * from "./TSACalendarNextItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__